import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { ZSwitch } from '../zswitch/zswitch';

const Container = styled.div<{ $isOld: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 6px 8px 6px 14px;
    border-radius: 999px;
    user-select: none;
    border: 1px solid ${({ $isOld }) => ($isOld ? '#f1c47a' : '#abdfb6')};
    background: ${({ $isOld }) => ($isOld ? '#fff7ea' : '#eef9f0')};
    transition:
        background 0.2s ease,
        border-color 0.2s ease;
`;

const StatusDot = styled.span<{ $isOld: boolean }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    background: ${({ $isOld }) => ($isOld ? '#e8920a' : '#2e9e4f')};
    box-shadow: 0 0 0 3px ${({ $isOld }) => ($isOld ? 'rgba(232, 146, 10, 0.18)' : 'rgba(46, 158, 79, 0.18)')};
`;

const StatusLabel = styled.span<{ $isOld: boolean }>`
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    color: ${({ $isOld }) => ($isOld ? '#8a5800' : '#1c7438')};
`;

interface ConfiguratorUrlSwitchProps {
    useOldUrl: boolean;
    onChange: (useOldUrl: boolean) => void;
    className?: string;
    ariaLabel?: string;
}

/**
 * Compact status pill + toggle that shows, at a glance, whether the new or the old configurator
 * interface is active and lets the user switch between them. Only rendered behind the configurator
 * URL switch feature flag; when off the new URL is always used. See {@link useConfiguratorUrlSwitchEnabled}.
 */
export const ConfiguratorUrlSwitch: FC<ConfiguratorUrlSwitchProps> = ({ useOldUrl, onChange, className, ariaLabel }) => (
    <Container $isOld={useOldUrl} className={className}>
        <StatusDot $isOld={useOldUrl} />
        <StatusLabel $isOld={useOldUrl}>{useOldUrl ? T._('Old interface is active', 'Admin') : T._('New interface is active', 'Admin')}</StatusLabel>
        <ZSwitch checked={useOldUrl} onChange={onChange} ariaLabel={ariaLabel ?? T._('Use the old configurator interface', 'Admin')} />
    </Container>
);
